import { pluralizeWithCount } from "@common/helpers/string";
import { ScheduleReviewConfirmActionBar } from "./ScheduleReviewConfirmActionBar";

interface MilestoneReviewTaskActionBarProps {
    selectedCount: number;
    totalCount: number;
    isBusy: boolean;
    onConfirmSelected: () => void;
    onConfirmAll: () => void;
}

export const MilestoneReviewTaskActionBar = ({
    selectedCount,
    totalCount,
    isBusy,
    onConfirmSelected,
    onConfirmAll,
}: MilestoneReviewTaskActionBarProps) => {
    if (totalCount === 0) {
        return null;
    }

    return (
        <ScheduleReviewConfirmActionBar
            selectedCount={selectedCount}
            totalCount={totalCount}
            isBusy={isBusy}
            confirmAllLabel="Confirm all due"
            confirmAllHotkeyDescription="Confirm all due milestones"
            confirmAllModal={{
                title: `Recognize ${pluralizeWithCount("milestone", totalCount)}?`,
                question:
                    "Each milestone posts its recognition journal entry on its posting date. A milestone in a locked month is left pending.",
                yes: "Recognize",
            }}
            onConfirmSelected={onConfirmSelected}
            onConfirmAll={onConfirmAll}
        />
    );
};
